<ul class="flex justify-left border-b border-gray-400 overflow-x-auto tabs-container horizontal-scrollbar" role="tablist">
  <ng-container *ngFor="let tab of tabs">
    <li *permissionsRequired="tab.permissions || null" class="min-w-max" role="tab">
      <a [routerLink]="tab.disabled ? null : tab.routerLink"
         routerLinkActive="border-blue-600 border-b-2 text-gray-dark"
         [class.disabled]="tab.disabled"
         class="transition ease-in-out duration-500 uppercase text-gray-light font-medium inline-block px-4 py-4 xl:text-lg lg:text-sm sm:text-xs">
        {{ tab.text }}
      </a>
    </li>
  </ng-container>
</ul>